import { FC } from 'react';
import ProblemTypeHierarchicalDisplay from '../../problem_type_hierarchical_display/ProblemTypeHierarchicalDisplay';

const TSProblemTypesDisplay: FC<any> = ({ problemTypes = [] }) => {
	const problemTypeIds = problemTypes.map((pt) => pt.id);
	return <ProblemTypeHierarchicalDisplay problemTypeIds={problemTypeIds} />;
};

export default TSProblemTypesDisplay;
